export default {
  'profileaccounts.accountsmanagement': 'Bankkontenverwaltung',
  'profileaccounts.bankname': 'Name der Bank',
  'profileaccounts.branchname': 'Filialname',
  'profileaccounts.accountno': 'Kontonummer',
  'profileaccounts.cardno': 'Kartennummer',
  'profileaccounts.shebano': 'Sheba Nummer',
  'profileaccounts.ismain': 'Ist das vorgegebene konto',
  'profileaccounts.register': 'Anmeldung',
  'profileaccounts.delete': 'löschen',
  'profileaccounts.deleteaccount': 'Bankkonto löschen',
  'proprofileaccountsfile.cancel': 'Abbrechen',
  'profileaccounts.deleteconfirmation':
    'Möchten Sie das Bankkonto wirklich löschen ?',
  'profileaccounts.accountadd': 'Bankkonto erfolgreich hinzugefügt!',
  'profileaccounts.tryagain': 'Bitte versuche es erneut',
  'profileaccounts.enterinfo': 'Kontoinformationen eingeben',
  'profileaccounts.addaccount': 'Bankkonto hinzufügen',
  'profileaccounts.cardno-account': 'Karten/Konto Nummer',
  'profileaccounts.Textaccountsmanage':
    'Sie können das gewünschte Konto über das folgende Formular registrieren.',
};
